module.exports = __webpack_public_path__ + "img/settings.9054952.png";